import api from "../api";

const getStores= async () => {

    try {

      const response = await api.get(process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/store?page=1&pageSize=9999");

      return response.data;
    }
     catch (error) {
      console.error('There was a problem with the axios operation:', error);
      throw error;
    }
  
}

export default getStores;
